import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Feature {
  name: string;
  external_cf_id: string;
  value: string;
}

interface FeatureGroup {
  name: string;
  external_cf_id: string;
  features: Feature[];
}

interface Label {
  featureGroupId: string;
  featureId: string;
  featureValue: string;
  width: number;
  height: number;
  alt: string;
  class: string;
  imageSrc: string;
}

interface Props {
  featureGroups: FeatureGroup[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureLabelGroup',
  props: {
    featureGroups: null
  },
  setup(__props: any) {

const props = __props as {
  featureGroups: FeatureGroup[];
};



const AVAILABLE_LABELS: Label[] = [
  {
    featureGroupId: 'ADDITIONAL_INFORMATION',
    featureId: 'PRODUCT_SERIES',
    featureValue: 'Hexagon',
    width: 120,
    height: 67,
    alt: 'hexagon-label',
    class: 'hexagon-label',
    imageSrc: '/img/product-features/hexagon-2x.png',
  },
];

const TARGET_FEATURE_GROUPS = ['ADDITIONAL_INFORMATION'];

const getLabelsToRender = (
  featureGroups: FeatureGroup[],
  availableLabels: Label[],
) => {
  return availableLabels.filter((label) =>
    featureGroups.some((featureGroup) =>
      featureGroup.features.some(
        (feature) =>
          feature.external_cf_id === label.featureId &&
          feature.value === label.featureValue,
      ),
    ),
  );
};

const filteredFeatureGroups = computed(() =>
  props.featureGroups.filter((group) =>
    TARGET_FEATURE_GROUPS.includes(group.external_cf_id),
  ),
);

const labelsToRender = computed(() =>
  getLabelsToRender(filteredFeatureGroups.value, AVAILABLE_LABELS),
);

return { __sfc: true,props, AVAILABLE_LABELS, TARGET_FEATURE_GROUPS, getLabelsToRender, filteredFeatureGroups, labelsToRender }
}

})